<template>
  <b-modal
    id="optionsModal"
    v-model="optionsModal.show"
    title="Options"
    ok-only
    @hidden="hideOptionsModal"
    @show="setValues"
    @shown="onShown"
  >
    <input-widget
      :model="form"
      :field="fields.factValues"
    />
    <!--    <input-widget :model="form" :field="fields.measuresValue"/>-->
    <input-widget
      :model="form"
      :field="fields.dimensionValue"
    />
    <input-widget
      :model="form"
      :field="fields.attributeValue"
    />
    <!--    <hr/>-->
    <!--    <h4>Display Options</h4>-->
    <!--&lt;!&ndash;    <input-widget :model="form" :field="fields.displayMeasures"/>&ndash;&gt;-->
    <!--    <input-widget :model="form" :field="fields.displayAttributes"/>-->
    <!--    <input-widget :model="form" :field="fields.displayMinorElements"/>-->
    <!--    <hr/>-->
    <!--    <h4>Appearance</h4>-->
    <!--    <input-widget :model="form" :field="fields.darkMode" :is-switch="true"/>-->
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import InputWidget from '../../core/components/complex-table/components/InputWidget';

const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'OptionsModal',
  components: {InputWidget},
  data() {
    return {
      form: {
        factValues: [],
        // measuresValue: [],
        dimensionValue: [],
        attributeValue: [],
        displayAttributes: false,
        // displayMeasures: false,
        displayMinorElements: false,
        darkMode: false,
      },
      fields: {
        displayAttributes: {
          type: 'checkbox',
          required: false,
          label: 'Show Attributes',
          name: 'displayAttributes',
        },
        /*displayMeasures: {
            type: 'checkbox',
            required: false,
            label: 'Show Measures',
            name: 'displayMeasures'
          },*/
        displayMinorElements: {
          type: 'checkbox',
          required: false,
          label: 'Show Minor Elements',
          name: 'displayMinorElements',
        },
        darkMode: {
          type: 'checkbox',
          required: false,
          label: 'Toggle Dark Mode',
          name: 'darkMode',
        },
        factValues: {
          type: 'multi-select',
          required: false,
          label: 'Facts:',
          name: 'factValues',
          multiple: true,
          config: {
            closeOnSelect: false,
            optionValue: 'value',
            optionLabel: 'text',
            placeholder: 'Select here',
          },
          data: {
            options: [
              {value: 'No Tags', text: 'No Tags'},
              {value: 'Another', text: 'Another'},
              {value: 'Anything', text: 'Anything'},
              {value: 'Cool', text: 'Cool'},
            ],
          },
        },
        /*measuresValue: {
            type: 'multi-select',
            required: false,
            label: 'Measures:',
            name: 'measuresValue',
            multiple: true,
            config: {
              closeOnSelect: false,
              optionValue: 'value',
              optionLabel: 'text',
              placeholder: ''
            },
            data: {
              options: [
                {value: 'No Tags', text: 'No Tags'},
              ]
            }
          },*/
        dimensionValue: {
          type: 'multi-select',
          required: false,
          label: 'Dimensions:',
          name: 'dimensionValue',
          multiple: true,
          config: {
            closeOnSelect: false,
            optionValue: 'value',
            optionLabel: 'text',
            placeholder: 'Select here',
          },
          data: {
            options: [
              {value: 'No Tags', text: 'No Tags'},
            ],
          },
        },
        attributeValue: {
          type: 'multi-select',
          required: false,
          label: 'Attributes:',
          name: 'attributeValue',
          multiple: true,
          config: {
            closeOnSelect: false,
            optionValue: 'value',
            optionLabel: 'text',
            placeholder: 'Select here',
          },
          data: {
            options: [
              {value: 'No Tags', text: 'No Tags'},
            ],
          },
        },
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.updateFilter(this.form);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['optionsModal']),
    ...mapState({
      optionsFilter: state => state.sunModel.optionsFilter,
    }),
  },
  methods: {
    ...mapActions(['hideOptionsModal', 'showAttributes', 'showMeasures', 'showMinor', 'updateFilter']),
    setValues() {
      for (const key in this.optionsFilter) {
        // console.log(key);
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = this.optionsFilter[key];
        }
      }
    },
    onShown() {
      const modal = document.getElementById('optionsModal');
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.hideOptionsModal();
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
